export const objectToUrl = (data: any) => {
  const jsonString = JSON.stringify(data);
  return encodeURIComponent(jsonString);
};

export const urlToObject = (url: any) => {
  try {
    const decodedString = decodeURIComponent(url);
    return JSON.parse(decodedString);
  } catch (err) {
    console.error("urlToObject function error:", err);
  }
};
